/* ============================================================
   PLEYNE — PDP craft layer logic (Shopify)
   Ported from web/pdp-craft.js. Reads a per-product config emitted by
   sections/pleyne-product.liquid (#pdp-craft-config) instead of window.PLEYNE,
   so it stays fully dynamic across every product, and every string is editable.
     1 · Anatomy    2 · Construction wipe   3 · Fit finder
     4 · Cloth note 5 · How it's made       6 · Delivery-by-date
   ============================================================ */
(function () {
  var cfgEl = document.getElementById('pdp-craft-config');
  if (!cfgEl) return;
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var fit = CFG.fit || {};
  var cm = CFG.commission || {};
  var apptUrl = CFG.appointmentUrl || '#';
  var contactUrl = CFG.contactUrl || '#';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------------- 1 · ANATOMY ----------------
     Points are resolved server-side (category template by product type, or a
     per-product metafield override) and arrive as CFG.anat = [{x,y,name,text}]. */
  var ANAT = Array.isArray(CFG.anat) ? CFG.anat.map(function (o) { return Object.assign({}, o); }) : [];

  var stage = document.getElementById('stage');
  var anatLayer = document.getElementById('anatLayer');
  var read = document.getElementById('anatRead');
  if (stage && anatLayer && read && ANAT.length) {
    var rNo = document.getElementById('arNo'),
        rName = document.getElementById('arName'),
        rText = document.getElementById('arText'),
        rTot = read.querySelector('.ar-tot');
    if (rTot) rTot.textContent = 'of ' + ('0' + ANAT.length).slice(-2);
    var SVGNS = 'http://www.w3.org/2000/svg';
    // margin callout parking spots; extend by alternating sides beyond 5
    var ANCH = [
      { lx: 67, ly: 40, side: 'r' }, { lx: 33, ly: 41, side: 'l' },
      { lx: 67, ly: 57, side: 'r' }, { lx: 33, ly: 71, side: 'l' },
      { lx: 67, ly: 82, side: 'r' }
    ];
    while (ANCH.length < ANAT.length) {
      var k = ANCH.length, right = k % 2 === 0;
      ANCH.push({ lx: right ? 67 : 33, ly: 18 + (k * 64 / Math.max(1, ANAT.length - 1)), side: right ? 'r' : 'l' });
    }

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'anat-lines');
    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('preserveAspectRatio', 'none');
    anatLayer.appendChild(svg);

    var dots = [], labels = [], lines = [], walkItems = [];
    var canHover = window.matchMedia('(hover: hover)').matches;
    var ANAT_IMG = (typeof CFG.anatImg === 'number') ? CFG.anatImg : 0;
    var cur = -1;

    ANAT.forEach(function (pt, i) {
      var a = ANCH[i];
      var ln = document.createElementNS(SVGNS, 'line');
      ln.setAttribute('x1', pt.x); ln.setAttribute('y1', pt.y);
      ln.setAttribute('x2', a.lx); ln.setAttribute('y2', a.ly);
      ln.setAttribute('vector-effect', 'non-scaling-stroke');
      svg.appendChild(ln); lines.push(ln);

      var b = document.createElement('button');
      b.className = 'anat-dot'; b.type = 'button';
      b.style.left = pt.x + '%'; b.style.top = pt.y + '%';
      b.textContent = (i + 1);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', pt.name || ('Detail ' + (i + 1)));
      anatLayer.appendChild(b); dots.push(b);

      var lb = document.createElement('button');
      lb.className = 'anat-label'; lb.type = 'button';
      lb.setAttribute('data-side', a.side);
      lb.style.left = a.lx + '%'; lb.style.top = a.ly + '%';
      lb.innerHTML = '<span class="num">' + (i + 1) + '</span>' +
        '<span class="hd"><span class="ln"></span><span class="desc"></span></span>';
      lb.querySelector('.ln').textContent = pt.name || '';
      lb.querySelector('.desc').textContent = pt.text || '';
      anatLayer.appendChild(lb); labels.push(lb);

      if (canHover) {
        [b, lb].forEach(function (el) {
          el.addEventListener('mouseenter', function () { reveal(i); });
          el.addEventListener('mouseleave', scheduleCollapse);
          el.addEventListener('focus', function () { reveal(i); });
          el.addEventListener('blur', scheduleCollapse);
        });
      } else {
        [b, lb].forEach(function (el) {
          el.addEventListener('click', function (e) { e.stopPropagation(); reveal(i); });
        });
      }
    });

    // walkthrough index — a numbered list under the plate so the pins are discoverable
    (function () {
      var saBlock = anatLayer.closest('.stack-anat');
      if (!saBlock) return;
      var walk = document.createElement('div');
      walk.className = 'anat-walk';
      walk.innerHTML = '<span class="aw-lab">' + (CFG.anatWalkLabel || 'Explore the make') + '</span>';
      ANAT.forEach(function (pt, i) {
        var w = document.createElement('button');
        w.type = 'button'; w.className = 'aw-item'; w.setAttribute('aria-pressed', 'false');
        w.innerHTML = '<span class="aw-no">' + ('0' + (i + 1)).slice(-2) + '</span><span class="aw-nm"></span>';
        w.querySelector('.aw-nm').textContent = pt.name || '';
        if (canHover) {
          w.addEventListener('mouseenter', function () { reveal(i); });
          w.addEventListener('mouseleave', scheduleCollapse);
          w.addEventListener('focus', function () { reveal(i); });
          w.addEventListener('blur', scheduleCollapse);
        }
        w.addEventListener('click', function () { reveal(i); });
        walk.appendChild(w); walkItems.push(w);
      });
      var rd = document.getElementById('anatRead');
      saBlock.insertBefore(walk, rd || null);
    })();

    ['pointerdown', 'pointerup', 'pointermove', 'click'].forEach(function (ev) {
      anatLayer.addEventListener(ev, function (e) { e.stopPropagation(); });
    });

    var collapseTimer = null;
    function scheduleCollapse() { clearTimeout(collapseTimer); collapseTimer = setTimeout(collapse, 110); }
    function reveal(i) {
      clearTimeout(collapseTimer);
      cur = (i + ANAT.length) % ANAT.length;
      dots.forEach(function (b, j) { b.setAttribute('aria-pressed', j === cur); });
      labels.forEach(function (l, j) { l.classList.toggle('on', j === cur); });
      lines.forEach(function (l, j) { l.classList.toggle('on', j === cur); });
      walkItems.forEach(function (w, j) { w.setAttribute('aria-pressed', j === cur); });
      var pt = ANAT[cur];
      rNo.textContent = ('0' + (cur + 1)).slice(-2);
      rName.textContent = pt.name || '';
      rText.textContent = pt.text || '';
      read.classList.remove('flash'); void read.offsetWidth; read.classList.add('flash');
    }
    function collapse() {
      cur = -1;
      dots.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      labels.forEach(function (l) { l.classList.remove('on'); });
      lines.forEach(function (l) { l.classList.remove('on'); });
      walkItems.forEach(function (w) { w.setAttribute('aria-pressed', 'false'); });
    }

    var arPrev = document.getElementById('arPrev'), arNext = document.getElementById('arNext');
    if (arPrev) arPrev.addEventListener('click', function () { reveal(cur < 0 ? 0 : cur - 1); });
    if (arNext) arNext.addEventListener('click', function () { reveal(cur < 0 ? 0 : cur + 1); });

    // editorial-only: the anatomy plate is the final stack image and is always live.
    anatLayer.style.display = '';
    var hintEl = anatLayer.querySelector('.anat-hint');
    if (hintEl) hintEl.innerHTML = '<b></b>' + (canHover ? (CFG.anatHintHover || 'Hover a point for detail') : (CFG.anatHintTap || 'Tap a point for detail'));
    if (!canHover) reveal(0);
  }

  /* ---------------- 2 · CONSTRUCTION WIPE ---------------- */
  var crStage = document.getElementById('crStage');
  if (crStage) {
    var capL = crStage.querySelector('.cr-cap.cr-cap-l');
    var min = 6, max = 94, dragging = false;
    function setX(px) {
      var r = crStage.getBoundingClientRect();
      var pct = Math.max(min, Math.min(max, ((px - r.left) / r.width) * 100));
      crStage.style.setProperty('--x', pct + '%');
      crStage.setAttribute('aria-valuenow', Math.round(pct));
      if (capL) capL.style.opacity = pct < 16 ? 0 : 1;
    }
    crStage.addEventListener('pointerdown', function (e) {
      dragging = true; try { crStage.setPointerCapture(e.pointerId); } catch (_) {}
      crStage.style.cursor = 'grabbing'; setX(e.clientX);
    });
    crStage.addEventListener('pointermove', function (e) { if (dragging) setX(e.clientX); });
    function endCr() { dragging = false; crStage.style.cursor = 'ew-resize'; }
    crStage.addEventListener('pointerup', endCr);
    crStage.addEventListener('pointercancel', endCr);
    crStage.setAttribute('tabindex', '0');
    crStage.addEventListener('keydown', function (e) {
      var v = parseFloat(getComputedStyle(crStage).getPropertyValue('--x')) || 50;
      if (e.key === 'ArrowLeft') { e.preventDefault(); crStage.style.setProperty('--x', Math.max(min, v - 4) + '%'); }
      if (e.key === 'ArrowRight') { e.preventDefault(); crStage.style.setProperty('--x', Math.min(max, v + 4) + '%'); }
    });
  }

  /* ---------------- 3 · FIT FINDER ----------------
     base size = height-band index into the product's own size scale (CFG.sizes);
     +1 if broad, -1 if lean, +1 if "between sizes". Result checked against the
     live size buttons (#sizeRow) for stock. Chest map comes from the size guide. */
  var ff = document.getElementById('fitFinder');
  if (ff && Array.isArray(CFG.sizes) && CFG.sizes.length) {
    var ffToggle = document.getElementById('ffToggle'),
        ffBody = document.getElementById('ffBody'),
        ffResult = document.getElementById('ffResult'),
        ffSize = ffResult.querySelector('.sz'),
        ffUk = ffResult.querySelector('.uk'),
        ffStatus = document.getElementById('ffStatus'),
        ffCta = document.getElementById('ffCta'),
        ffSay = document.getElementById('ffSay');
    ffToggle.addEventListener('click', function () {
      var open = ff.classList.toggle('open');
      ffBody.style.maxHeight = open ? ffBody.scrollHeight + 'px' : 0;
    });
    var pick = { height: null, build: null, between: null };
    function segGroup(key) {
      ff.querySelectorAll('.ff-seg[data-k="' + key + '"] button').forEach(function (b) {
        b.addEventListener('click', function () {
          pick[key] = b.getAttribute('data-v');
          b.parentNode.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
          recompute();
        });
      });
    }
    segGroup('height'); segGroup('build'); segGroup('between');

    var SIZES = CFG.sizes;                       // e.g. ['38','40','42','44','46'] — the product's own scale
    var CHEST = CFG.chest || {};                 // { '40':'40–41″', ... } from the size guide
    var HBAND = CFG.heightBands || [];           // labels, parallel to height index
    function sizeBtn(sz) {
      return [].slice.call(document.querySelectorAll('#sizeRow .size'))
        .filter(function (b) { return b.getAttribute('data-value') === sz || b.textContent.trim() === sz; })[0];
    }
    function inStock(sz) { var b = sizeBtn(sz); return !!(b && !b.disabled); }
    function recompute() {
      if (pick.height === null || pick.build === null) return;
      var idx = parseInt(pick.height, 10);
      if (pick.build === 'broad') idx += 1;
      if (pick.build === 'lean') idx -= 1;
      if (pick.between === 'yes') idx += 1;

      var inRange = idx >= 0 && idx <= SIZES.length - 1;
      var size = inRange ? String(SIZES[idx]) : (idx < 0 ? String(SIZES[0]) : String(SIZES[SIZES.length - 1]));
      var available = inRange && inStock(size);

      var basis = (HBAND[pick.height] || '') + ' · ' + pick.build + ' build'
        + (pick.between === 'yes' ? ' · between sizes' : '');
      var fitLine = pick.build === 'lean' ? (fit.lean || '')
        : pick.build === 'broad' ? (fit.broad || '')
        : (fit.regular || '');

      ffSize.textContent = size;
      if (ffUk) ffUk.textContent = (fit.uk_prefix || 'UK') + ' · ' + (CHEST[size] || '') + (CHEST[size] ? ' chest' : '');
      ffResult.classList.toggle('oos', !available);
      if (ffStatus) ffStatus.textContent = available ? (fit.in_stock || 'In stock') : (fit.made_to_order || 'Made to order');

      if (available) {
        ffSay.innerHTML =
          '<p>' + fitLine + '</p>' +
          (fit.starting_point ? '<p>' + fit.starting_point + '</p>' : '') +
          '<p class="ff-basis">' + (fit.basis_prefix || 'Based on') + ' ' + basis + '.</p>';
        if (ffCta) ffCta.innerHTML =
          '<a class="btn-fit" href="' + apptUrl + '">' + (fit.cta_book || 'Book a fitting') + ' <span aria-hidden="true">→</span></a>';
        document.querySelectorAll('#sizeRow .size').forEach(function (b) {
          if ((b.getAttribute('data-value') === size || b.textContent.trim() === size) && !b.disabled) { b.click(); }
        });
      } else {
        var msg = (idx < 0)
          ? (fit.below_msg || 'Your measurements point to below our smallest ready size. The smaller sizes we cut to order.')
          : (fit.mto_msg || 'Your measurements point to a size we currently cut to order, not held in ready stock.');
        msg = msg.replace('{size}', '<b>' + esc(size) + '</b>');
        ffSay.innerHTML =
          '<p>' + msg + '</p>' +
          (fit.mto_followup ? '<p>' + fit.mto_followup + '</p>' : '') +
          '<p class="ff-basis">' + (fit.basis_prefix || 'Based on') + ' ' + basis + '.</p>';
        if (ffCta) ffCta.innerHTML =
          '<a class="btn-fit" href="' + apptUrl + '">' + (fit.cta_book || 'Book a fitting') + ' <span aria-hidden="true">→</span></a>' +
          '<a class="lnk" href="' + contactUrl + '">' + (fit.cta_contact || 'Contact the atelier') + '</a>';
        if (idx >= 0) { var b2 = sizeBtn(size); if (b2) { b2.classList.add('flag'); setTimeout(function () { b2.classList.remove('flag'); }, 2400); } }
      }
      ffResult.classList.add('show');
      if (ff.classList.contains('open')) ffBody.style.maxHeight = ffBody.scrollHeight + 'px';
    }
  }

  /* ---------------- 4 · CLOTH NOTE ---------------- */
  var clothNote = document.getElementById('clothNote');
  var colorRow = document.getElementById('colorRow');
  var CLOTHMAP = CFG.clothMap || {};
  function setCloth(name) {
    if (!clothNote) return;
    var cloth = CFG.cloth || CLOTHMAP[name] || (CFG.clothFallback || 'A house cloth, woven to order');
    clothNote.innerHTML = '<b>' + esc(name) + '</b> &middot; ' + esc(cloth);
  }
  if (colorRow && clothNote) {
    colorRow.addEventListener('click', function (e) {
      var b = e.target.closest('.swatch'); if (!b) return;
      var name = b.getAttribute('data-value') || b.title || '';
      setCloth(name);
    });
    var firstSwatch = colorRow.querySelector('.swatch');
    setCloth(firstSwatch ? (firstSwatch.getAttribute('data-value') || firstSwatch.title || '') : '');
  }
  var clothToggle = document.getElementById('clothToggle');
  if (clothToggle && clothNote) {
    var clothWrap = document.getElementById('clothNoteWrap') || clothNote;
    clothToggle.addEventListener('click', function () {
      var open = clothToggle.getAttribute('aria-expanded') !== 'true';
      clothToggle.setAttribute('aria-expanded', open);
      if (open) {
        clothWrap.style.maxHeight = clothWrap.scrollHeight + 'px';
        setTimeout(function () { if (clothToggle.getAttribute('aria-expanded') === 'true') clothWrap.style.maxHeight = 'none'; }, 420);
      } else {
        clothWrap.style.maxHeight = clothWrap.scrollHeight + 'px';
        void clothWrap.offsetWidth;
        clothWrap.style.maxHeight = 0;
      }
    });
    clothToggle.setAttribute('aria-expanded', 'true');
    clothWrap.style.maxHeight = 'none';
  }

  /* ---------------- 5 · HOW IT'S MADE: collapsible + before/after ---------------- */
  var craftHead = document.getElementById('craftHead');
  var craft = craftHead && craftHead.closest('.craft');
  if (craftHead && craft) {
    craftHead.addEventListener('click', function () {
      var open = craftHead.getAttribute('aria-expanded') !== 'true';
      craftHead.setAttribute('aria-expanded', open);
      craft.classList.toggle('open', open);
    });
  }

  /* ---------------- 6 · DELIVERY-BY-DATE (computed locally, nothing stored) ---------------- */
  var cmTrack = document.getElementById('cmTrack');
  if (cmTrack) {
    var cmDate = document.getElementById('cmDate'),
        cmEvent = document.getElementById('cmEvent'),
        cmWhen = document.getElementById('cmWhen'),
        cmRead = document.getElementById('cmRead');
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var lead = parseInt(cm.lead_days, 10) || 28;
    var noDate = cm.default_read || 'Made to order — about four weeks from first fitting to final press.';
    function fmt(d) { return d.getDate() + ' ' + MON[d.getMonth()]; }
    function tmpl(s, ds, wk) { return (s || '').replace('{date}', ds).replace('{weeks}', wk); }
    if (cmDate) {
      cmDate.min = new Date().toISOString().slice(0, 10);
      cmDate.addEventListener('change', update);
      cmDate.addEventListener('input', update);
    }
    function update() {
      var val = cmDate ? cmDate.value : '';
      if (!val) {
        cmEvent.classList.remove('show');
        cmWhen.textContent = cm.no_date_label || 'No date set';
        cmRead.classList.remove('warn');
        cmRead.innerHTML = noDate;
        cmTrack.style.setProperty('--fill', '66%');
        return;
      }
      var ev = new Date(val + 'T00:00:00');
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var d = Math.round((ev - today) / 86400000);
      cmWhen.textContent = fmt(ev) + (ev.getFullYear() !== today.getFullYear() ? (' ’' + String(ev.getFullYear()).slice(-2)) : '');
      var ds = fmt(ev), warn = false, msg;
      if (d < 0) {
        cmEvent.classList.remove('show'); warn = true;
        msg = cm.msg_past || 'That date has already passed — choose another.';
      } else {
        var pct = Math.max(5, Math.min(96, 5 + d * 2.179));
        cmEvent.style.left = pct + '%';
        cmEvent.classList.add('show');
        if (d >= lead + 7) {
          var wk = Math.max(1, Math.round((d - lead) / 7));
          msg = tmpl(cm.msg_early || 'Order today and it’s ready with {weeks} week(s) to spare before {date}.', ds, wk + (wk === 1 ? ' week' : ' weeks'));
        } else if (d >= lead) {
          msg = tmpl(cm.msg_ontime || 'Ready just in time for {date} — about a week’s grace.', ds);
        } else if (d >= lead - 7) {
          warn = true;
          msg = tmpl(cm.msg_close || '{date} is close for made-to-order. We’ll prioritise it — <a href="' + apptUrl + '">book a fitting</a> to confirm.', ds);
        } else {
          warn = true;
          msg = tmpl(cm.msg_rush || '{date} is very soon for a hand-finished piece. Speak to the atelier — <a href="' + apptUrl + '">book a fitting</a>.', ds);
        }
      }
      cmRead.classList.toggle('warn', warn);
      cmRead.innerHTML = msg;
    }
  }

  /* ---------------- SIZE GUIDE MODAL ---------------- */
  (function () {
    var modal = document.getElementById('sizeGuide'), openBtn = document.getElementById('sizeGuideBtn');
    if (!modal || !openBtn) return;
    function open() { modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    openBtn.addEventListener('click', open);
    var x = document.getElementById('sgClose'); if (x) x.addEventListener('click', close);
    modal.querySelectorAll('[data-sg-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
  })();
})();
